
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {closeModal} from 'redux/modules/ui/modal/actions'
import PromptContainer from 'components/PromptContainer'
import ButtonsGroup from 'components/ButtonsGroup'
import Checkbox from 'components/Checkbox'
import ChannelIcon from 'components/ChannelIcon'
import partial from 'utils/partial'
import {connect} from 'react-redux'

export class ChannelSelectorModal extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    groups: PropTypes.array,
    channelTypes: PropTypes.array,
    selected: PropTypes.array,
    types: PropTypes.array,
    onSelect: PropTypes.func,
    isSingle: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: [],
      types: [],
    }
  }

  componentWillMount() {
    const {selected, types} = this.props

    this.setState({selected: selected || [], types: types || []})
  }

  render() {
    const {closeModal, isSingle} = this.props
    const title = isSingle ? 'Select channel' : 'Select channel or channel group'

    return (
      <PromptContainer
        className='channel-selector-view'
        title={title}
        onClose={closeModal}
      >
        {this.renderSelector()}
        <ButtonsGroup align='center' className='channel-selector-view_buttons'>
          <button type='button' onClick={this.onClear}>Clear</button>
          <button type='submit' onClick={this.onSave}>Save</button>
        </ButtonsGroup>
      </PromptContainer>
    )
  }

  renderSelector() {
    return (
      <div className='channel-selector-view_selector'>
        {this.renderChannelType()}
        {this.renderGroups()}
      </div>
    )
  }

  renderChannelType() {
    const {channelTypes} = this.props
    return (
      <div className='channel-selector-view_group channel-type'>
        <div className='channel-selector-view_group_title'>
          Channel Type
        </div>
        <div className='channel-selector-view_group_checkboxes'>
          <div className='channel-selector-view_group_checkboxes_others'>
            {channelTypes.map((channelType, index) => this.renderType(channelType, index))}
          </div>
        </div>
      </div>
    )
  }

  renderGroups() {
    const {groups} = this.props

    return groups.map(this.renderGroup)
  }

  renderGroup = (item, index) => {
    const {id: channelGroupKey, label, channels} = item
    const {isSingle} = this.props

    return (
      <div className='channel-selector-view_group' key={index}>
        <div className='channel-selector-view_group_title'>
          {label}
        </div>
        <div className='channel-selector-view_group_checkboxes'>
          {!isSingle && <div className='channel-selector-view_group_checkboxes_all'>
            <Checkbox
              className='channel-selector-view_group_checkbox'
              color={channelGroupKey}
              checked={this.isGroupSelected(channelGroupKey)}
              onChange={partial(this.onGroupChange, channelGroupKey)}
            />
          </div>
          }
          <div className='channel-selector-view_group_checkboxes_others'>
            {channels.map(partial(this.renderChannel, channelGroupKey))}
          </div>
        </div>
      </div>
    )
  }

  renderChannel = (channelGroupKey, item, index) => {
    const {id: channelKey, label} = item

    if (channelKey === 'prisjakt') return null

    const isGroupSelected = this.isGroupSelected(channelGroupKey)
    const isChannelSelected = this.isChannelSelected(channelGroupKey, channelKey)
    const isSelected = isGroupSelected || isChannelSelected

    return (
      <div className='channel-selector-view_group_channel' key={index}>
        <ChannelIcon
          name={channelKey}
          group={channelGroupKey}
          active={isSelected}
          tooltip={label}
          onClick={partial(this.onChannelChange, channelGroupKey, channelKey, !isSelected)}
        />
      </div>
    )
  }

  renderType = (item, index) => {
    const {id: channelType, label} = item

    const isSelected = this.isTypeSelected(channelType)

    return (
      <div className='channel-selector-view_group_channel' key={index}>
        <ChannelIcon
          name={`type_${channelType}`}
          group={'channeltype'}
          active={isSelected}
          tooltip={label}
          onClick={partial(this.onTypeChange, channelType, !isSelected)}
        />
      </div>
    )
  }

  onGroupChange = (channelGroup, value) => {
    const {selected} = this.state
    const newSelected = value
      ? selected.concat({channelGroup, channel: false})
      : selected.filter(item => item.channelGroup !== channelGroup)

    this.setState({selected: newSelected})
  }

  onChannelChange = (channelGroup, channel, value) => {
    const {selected} = this.state
    let newSelected
    if (this.props.isSingle) {
      newSelected = value ? [{channelGroup, channel}] : []
    } else {
      newSelected = value
        ? selected.concat({channelGroup, channel})
        : selected.filter(item => {
          return !(item.channelGroup === channelGroup && item.channel === channel)
        })
    }
    this.setState({selected: newSelected})
  }

  onTypeChange = (channelType, value) => {
    const {types} = this.state
    let newSelected
    if (this.props.isSingle) {
      newSelected = value ? [channelType] : []
    } else {
      newSelected = value
        ? types.concat(channelType)
        : types.filter(item => {
          return !(item === channelType)
        })
    }
    this.setState({types: newSelected})
  }

  onSave = () => {
    const {onSelect, closeModal} = this.props
    const {selected, types} = this.state

    onSelect && onSelect(selected, types)
    closeModal()
  }

  onClear = () => {
    this.setState({
      selected: [],
      types: []
    })
  }

  isGroupSelected(channelGroupKey) {
    const {selected} = this.state
    return !!selected.find(item => {
      return !item.channel && item.channelGroup === channelGroupKey
    })
  }

  isChannelSelected(channelGroupKey, channelKey) {
    const {selected} = this.state
    return !!selected.find(item => {
      return item.channel === channelKey && item.channelGroup === channelGroupKey
    })
  }

  isTypeSelected(channelType) {
    const {types} = this.state
    return types.includes(channelType)
  }
}

const mapStateToProps = state => ({})
const mapDispatchToProps = {
  closeModal
}

export default connect(mapStateToProps, mapDispatchToProps)(ChannelSelectorModal)



// WEBPACK FOOTER //
// ./client/modals/ChannelSelectorModal/index.js